// extracted by mini-css-extract-plugin
export default {"class_ct":"RsvRegiInfo_class_ct__3zxdp","pagination":"RsvRegiInfo_pagination__xzJGN","activePage":"RsvRegiInfo_activePage__CUXmn","no_admin":"RsvRegiInfo_no_admin__ngOQL"};